import * as OAuth from "oauth2";
import * as OAuthSW from "./oauth";
import * as MessengerApp from "service-worker/es/messenger/app";
import * as MessengerShared from "service-worker/es/messenger/shared";
import * as Logger from "./logger/app";

const script = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js", {
        type: "module",
        scope: "/",
      });

      try {
        await registration.update();
      } catch (updateErr) {
        // Ex: Si pas de connexion internet
        console.warn("[SW] update failed, keeping the last one:", updateErr);
      }

      await navigator.serviceWorker.ready;

      if (!navigator.serviceWorker.controller) {
        await MessengerApp.sendMessageToSW({
          type: "HARD_RELOAD",
        });
      }

      navigator.serviceWorker.addEventListener("message", async (event) => {
        // Bien await les fonctions onMessage, sinon on envoie une réponse
        // vide prématurément (MessengerShared.answerMessage(event, undefined)).
        await MessengerApp.onMessage(event);
        await Logger.onMessage(event);
        await OAuthSW.onMessage(event);

        if (event.ports && event.ports[0]) {
          MessengerShared.answerMessage(event, undefined);
        }
      });

      //Transfert des dépendances du service worker
      const token = OAuth.getAccessToken();
      const user = OAuth.userFromStorage();
      const auth = token && user ? { token, user } : undefined;
      await OAuthSW.sendAuth(auth);
    } catch (err) {
      console.error(err);
    }
  }
};
export default script;
